import React from 'react';

import AccessDeviceTableRow from './AccessDeviceTableRow';

import AccessDevice from '../../Entities/AccessDevice';

import './AccessDeviceTable.scss';


class AccessDeviceTable extends React.Component {
  _onAccessDeviceChange(ident) {
    return value => {
      this.props.onAccessDeviceChange(ident, value);
    };
  }


  handleAddAccessDeviceClick = () => {
    this._onAccessDeviceChange(null)(new AccessDevice());
  }


  render() {
    const {
      accessDeviceRows = [],
      inputId,
      allowAdd,
      editMode,
      fieldConfiguration,
      disabledMode
    } = this.props;

    const activeAccessDeviceTypes = [];
    for (let accessDeviceRow of accessDeviceRows) {
      if (accessDeviceRow.data.fields.type.value) {
        activeAccessDeviceTypes.push(accessDeviceRow.data.fields.type.value);
      }
    }

    return (
      <div className="parkchirp--access-device-table">
        <header className="parkchirp--access-device-table--header">
          <div className={`parkchirp--access-device-table--cell` +
            ` parkchirp--access-device-table--device-type-column`}>
            <span className="parkchirp--access-device-table--column-heading">Device Type</span>
          </div>
          <div className={`parkchirp--access-device-table--cell` +
            ` parkchirp--access-device-table--device-offered-column`}>
            <span className="parkchirp--access-device-table--column-heading">Offered</span>
          </div>
          <div className={`parkchirp--access-device-table--cell` +
            ` parkchirp--access-device-table--device-required-column`}>
            <span className="parkchirp--access-device-table--column-heading">Required</span>
          </div>
          <div className={`parkchirp--access-device-table--cell` +
            ` parkchirp--access-device-table--device-charge-column`}>
            <span className="parkchirp--access-device-table--column-heading">Charge</span>
          </div>
          <div className={`parkchirp--access-device-table--cell` +
            ` parkchirp--access-device-table--actions-column`}>
          </div>
        </header>
        <div className="parkchirp--access-device-table--body">
          {accessDeviceRows.map(accessDeviceRow => {
            return (
              <AccessDeviceTableRow inputId={inputId}
                key={accessDeviceRow.ident}
                ident={accessDeviceRow.ident}
                accessDevice={accessDeviceRow.data}
                onValueChange={this._onAccessDeviceChange(accessDeviceRow.ident)}
                fieldConfiguration={fieldConfiguration}
                activeAccessDeviceTypes={activeAccessDeviceTypes}
                editMode={editMode}
                disabledMode={disabledMode}
              />
            );
          })}
        </div>
        {(allowAdd) &&
          <footer className="parkchirp--access-device-table--footer">
            <div className="parkchirp--access-device-table--cell">
              <button type="button"
                className="parkchirp--button-as-link"
                onClick={this.handleAddAccessDeviceClick}>
                Add Access Device
              </button>
            </div>
          </footer>
        }
      </div>
    );
  }
}
export default AccessDeviceTable;
